'use client';

import * as React from 'react';
import { useRaiseHand } from '@/lib/useRaiseHand';
import { ru } from '@/lib/ru';
import { RaiseHandIcon } from './RaiseHandIcon';

export function RaiseHandButton(props: {
  showIcon?: boolean;
  showText?: boolean;
  shortcutLabel?: string;
}) {
  const { showIcon = true, showText = true, shortcutLabel } = props;
  const { isRaised, toggleRaiseHand } = useRaiseHand();
  const [pending, setPending] = React.useState(false);

  const label = isRaised ? ru.lowerHand : ru.raiseHand;

  const onClick = async () => {
    if (pending) return;
    setPending(true);
    try {
      await toggleRaiseHand();
    } catch (error) {
      console.error('Raise hand failed', error);
    } finally {
      setPending(false);
    }
  };

  return (
    <button
      className="lk-button"
      type="button"
      aria-pressed={isRaised ? 'true' : 'false'}
      aria-label={label}
      title={shortcutLabel}
      data-lk-enabled={String(isRaised)}
      data-agima-raised={isRaised ? 'true' : 'false'}
      disabled={pending}
      onClick={onClick}
    >
      {showIcon && <RaiseHandIcon />}
      {showText && label}
    </button>
  );
}
